// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_mf-0";
export var buttonContainer = "_mf-3";
export var cancelButton = "_mf-4";
export var headerSection = "_mf-6";
export var headerTitle = "_mf-9";
export var messageSideLeft = "_mf-1";
export var messageSideRight = "_mf-2";
export var orderNumberContainer = "_mf-7";
export var orderNumberLabel = "_mf-8";
export var submitButton = "_mf-5";